import { gql } from "graphql-request";

export const CREATE_TENANT_USER = gql`
  mutation CreateTenantUser($input: CreateTenantUserInput!) {
    createTenantUser(input: $input) {
      id
      tenantId
      userId
      accessRole
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const UPDATE_TENANT_USER = gql`
  mutation UpdateTenantUser($input: UpdateTenantUserInput!) {
    updateTenantUser(input: $input) {
      id
      tenantId
      userId
      accessRole
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const ARCHIVE_TENANT_USER = gql`
  mutation ArchiveTenantUser($id: ID!) {
    archiveTenantUser(id: $id)
  }
`;